// External
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Internal
import { ModalName, ModalRoutelessService } from '../../components/ui/ui-modal-routeless/modal.routeless.service';
import { ConfigService } from '../../config/config.service';

@Injectable({
    providedIn: 'root'
})

export class PremiumResolver {

    constructor(
        private readonly configService: ConfigService,
        private readonly modalRoutelessService: ModalRoutelessService
    ) {}

    resolve(): Observable<any> {
        return new Observable( subscriber => {
            if (!this.configService.getPremiumServices()) {
                this.modalRoutelessService.open(ModalName.wrongLangModal, { buttonDismissable: false }, {});
            }
            subscriber.next(true);
            subscriber.complete();
        });
    }

}
